<template>
  <Modal
		class="long-modal"
	 	width="1000"
		style="max-height:70%;overflow:auto"
		v-model="show"
		:mask-closable="false"
    :loading="loading"
	>
		<div slot="header" class="modal-header">查看客户画像</div>
		<div class="readOnly">
		<div v-if="formData.realName">姓名：
        {{formData.realName}}
      </div>
      <div v-if="formData.customerMobile">电话：
        {{formData.customerMobile}}
      </div>
      <div v-if="formData.customerSexName">性别：
        {{formData.customerSexName}}
      </div>
      <div v-if="formData.idTypeName">证件信息：
        {{formData.idTypeName}}{{formData.idNo}}
      </div>
      <div v-if="formData.customerBirthday">出生年月：
        {{formData.customerBirthday}}
      </div>
      <div v-if="formData.age">年龄：
        {{formData.age}}
      </div>
      <div v-if="formData.nationCodeName">国籍：
        {{formData.nationCodeName}}
      </div>
      <div v-if="formData.provinceCodeName">籍贯：
        {{formData.provinceCodeName}}
      </div>
			<div v-if="formData.customerEduName">学历：
        {{formData.customerEduName}}
      </div>

			<div v-if="formData.currentStatusName">当前状态：
        {{formData.currentStatusName}}
        <span v-if="formData.currentStatusMsg">{{formData.currentStatusMsg}}</span>
      </div>
      <div v-if="formData.workAddressName">工作地点：
        {{formData.workAddressName}}
      </div>
			<div v-if="formData.originalName">机构名称：
        {{formData.originalName}}
      </div>
			<div v-if="formData.salaryRangeName">薪资范围：
        {{formData.salaryRangeName}}
      </div>
			<div v-if="formData.channelName">获知自如寓渠道：
        {{formData.channelName}}
        <span v-if="formData.channelMsg">{{formData.channelMsg}}</span>
      </div>
			<div v-if="formData.impressionName">自如寓印象：
        {{formData.impressionName}}
        <span v-if="formData.impressionMsg">{{formData.impressionMsg}}</span>
      </div>
			<!-- 找房 -->
			<div v-if="formData.intentionInTime">期望入住时间：
        {{formData.intentionInTime}}
      </div>
			<div v-if="formData.budgetRangeName">预算范围：
        {{formData.budgetRangeName}}
      </div>
      <div v-if="formData.checkinNum">几人居住：
        {{formData.checkinNum}}
      </div>
			<div v-if="formData.houseTypeName">意向房型：
        {{formData.houseTypeName}}
      </div>
			<div v-if="formData.intentionAreaName">意向面积：
        {{formData.intentionAreaName}}
      </div>
			<div v-if="formData.intentionAddressName">意向居住地点：
        {{formData.intentionAddressName}}
      </div>
			<div v-if="formData.rentTypeName">期望租住时长：
        {{formData.rentTypeName}}
        <span v-if="formData.rentTypeName&&formData.rentLength">
          {{formData.rentLength}}
          <span v-if="formData.rentType==1">年</span>
				  <span v-if="formData.rentType==2">月</span>
        </span>
      </div>
			<div v-if="formData.shortRentDesName">短租用途：
        {{formData.shortRentDesName}}
      </div>
			<div v-if="formData.commutingModeName">通勤方式：
        {{formData.commutingModeName}}
      </div>
      <div v-if="formData.commutingDuration">期望通勤时长：
        {{formData.commutingDuration}}
      </div>

      <div v-if="formData.jobTradeDirectionName">行业/方向：
        {{formData.jobTradeDirectionName}}
      </div>

			 <!-- /\ -->
      <div v-if="formData.currentCheckinStatusName">当前入住状态：
        {{formData.currentCheckinStatusName}}
        <span v-if="formData.currentCheckinMsg">{{formData.currentCheckinMsg}}</span>
      </div>
			<div v-if="formData.intentionLevelName">找房需求紧急度：
        {{formData.intentionLevelName}}
      </div>
			<div v-if="formData.rentEndTime">当前居住房屋到期时间：
        {{formData.rentEndTime}}
      </div>
      <div v-if="formData.residenceName">当前居住地点：
        {{formData.residenceName}}
      </div>
    </div>
<!--		</div>-->
	</Modal>
</template>

<script>
import {getCustomerPortrait} from 'api/business'
export default {
	props:{
		n:{
			type:Number,
			default:0
		},
		uid:{
			type:String,
			default:''
		}
	},
	data(){
		return{
			loading:false,
			show:false,
			formData:{},
		}
	},
	watch:{
		n(){
			this.show = true
			this.getDetails(this.uid)
		}
	},
	methods:{
		getDetails(uid){
			getCustomerPortrait({uid:uid}).then( res=>{
				this.formData = res.data;
				console.log(this.formData)
			})
		},
	}
}
</script>

<style scoped>
	.readOnly div{
		width: 40%;
		margin-bottom:16px;
		margin-left:16px;
		display: inline-block;
}
</style>
